// components/student/MyCourses.js
import React, { useState, useMemo, useEffect } from "react";
import ReactDOM from "react-dom";
import MyStudentLayout from "./../../../layouts/Student/MyStudentLayout";
import "../../../assets/css/student/MyCourses.css";

// ─── SVG ICONS ────────────────────────────────────────────────────────────────
const Icons = {
  Book: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  Clock: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  CheckCircle: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  BarChart: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
      <line x1="2" y1="20" x2="22" y2="20" />
    </svg>
  ),
  Clipboard: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
      <line x1="9" y1="12" x2="15" y2="12" />
      <line x1="9" y1="16" x2="13" y2="16" />
    </svg>
  ),
  Search: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Grid: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
    </svg>
  ),
  List: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" />
      <line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" />
      <line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  ),
  Close: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Play: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  ),
  EmptyState: () => (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="20" y="15" width="64" height="80" rx="6" stroke="#781c2e" strokeWidth="2" strokeOpacity="0.3"/>
      <rect x="28" y="25" width="32" height="4" rx="2" fill="#781c2e" fillOpacity="0.2"/>
      <rect x="28" y="35" width="48" height="3" rx="1.5" fill="#781c2e" fillOpacity="0.15"/>
      <rect x="28" y="44" width="40" height="3" rx="1.5" fill="#781c2e" fillOpacity="0.15"/>
      <rect x="28" y="53" width="44" height="3" rx="1.5" fill="#781c2e" fillOpacity="0.15"/>
      <circle cx="85" cy="82" r="22" fill="#faf8f5" stroke="#781c2e" strokeWidth="2" strokeOpacity="0.4"/>
      <line x1="85" y1="74" x2="85" y2="82" stroke="#781c2e" strokeWidth="2" strokeOpacity="0.5" strokeLinecap="round"/>
      <line x1="85" y1="82" x2="91" y2="88" stroke="#781c2e" strokeWidth="2" strokeOpacity="0.5" strokeLinecap="round"/>
      <circle cx="85" cy="82" r="2" fill="#781c2e" fillOpacity="0.5"/>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  User: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  Activity: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
    </svg>
  ),
};

// ─── DATA ─────────────────────────────────────────────────────────────────────
const COURSES = [
  {
    id: 1,
    title: "Complete Web Development",
    instructor: "Hamza Yaqoob",
    progress: 65,
    totalLectures: 120,
    completedLectures: 78,
    status: "in-progress",
    lastActivity: "2 hours ago",
    pendingAssignments: 3,
    accent: "blue",
    weeklyProgress: [
      { week: "Wk 1", score: 40 },
      { week: "Wk 2", score: 50 },
      { week: "Wk 3", score: 60 },
      { week: "Wk 4", score: 65 },
    ],
    topics: [
      { name: "HTML & CSS", completion: 100 },
      { name: "JavaScript Basics", completion: 80 },
      { name: "React Fundamentals", completion: 60 },
      { name: "Backend Development", completion: 40 },
    ],
  },
  {
    id: 2,
    title: "Advanced JavaScript",
    instructor: "Muhammad Imran",
    progress: 40,
    totalLectures: 80,
    completedLectures: 32,
    status: "in-progress",
    lastActivity: "1 day ago",
    pendingAssignments: 2,
    accent: "purple",
    weeklyProgress: [
      { week: "Wk 1", score: 20 },
      { week: "Wk 2", score: 28 },
      { week: "Wk 3", score: 35 },
      { week: "Wk 4", score: 40 },
    ],
    topics: [
      { name: "ES6+ Features", completion: 70 },
      { name: "Async Programming", completion: 50 },
      { name: "Design Patterns", completion: 30 },
      { name: "Testing", completion: 10 },
    ],
  },
  {
    id: 3,
    title: "React Mastery",
    instructor: "Ayesha Siddiqui",
    progress: 25,
    totalLectures: 60,
    completedLectures: 15,
    status: "in-progress",
    lastActivity: "3 days ago",
    pendingAssignments: 5,
    accent: "orange",
    weeklyProgress: [
      { week: "Wk 1", score: 10 },
      { week: "Wk 2", score: 15 },
      { week: "Wk 3", score: 20 },
      { week: "Wk 4", score: 25 },
    ],
    topics: [
      { name: "Components & Props", completion: 60 },
      { name: "State Management", completion: 40 },
      { name: "Hooks", completion: 20 },
      { name: "Advanced Patterns", completion: 5 },
    ],
  },
  {
    id: 4,
    title: "Node.js & REST APIs",
    instructor: "Sarah Khan",
    progress: 100,
    totalLectures: 55,
    completedLectures: 55,
    status: "completed",
    lastActivity: "1 week ago",
    pendingAssignments: 0,
    accent: "green",
    weeklyProgress: [
      { week: "Wk 1", score: 60 },
      { week: "Wk 2", score: 78 },
      { week: "Wk 3", score: 90 },
      { week: "Wk 4", score: 100 },
    ],
    topics: [
      { name: "Express.js", completion: 100 },
      { name: "Authentication", completion: 100 },
      { name: "Database Integration", completion: 100 },
      { name: "Deployment", completion: 100 },
    ],
  },
];

// ─── SUB-COMPONENTS ────────────────────────────────────────────────────────────

function ProgressBar({ value, accent = "garnet", size = "md" }) {
  return (
    <div className={`progress-bar progress-bar--${size}`}>
      <div
        className={`progress-bar__fill progress-bar__fill--${accent}`}
        style={{ width: `${value}%` }}
      />
    </div>
  );
}

function StatusBadge({ status }) {
  return (
    <span className={`status-badge status-badge--${status}`}>
      {status === "completed" ? "Completed" : "In Progress"}
    </span>
  );
}

function KpiCard({ icon: Icon, label, value, accent }) {
  return (
    <div className={`kpi-card kpi-card--${accent}`}>
      <div className={`kpi-card__icon kpi-card__icon--${accent}`}>
        <Icon />
      </div>
      <div className="kpi-card__body">
        <p className="kpi-card__label">{label}</p>
        <p className="kpi-card__value">{value}</p>
      </div>
    </div>
  );
}

function CircularProgress({ value, size = 140 }) {
  const r = (size - 16) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ * (1 - value / 100);
  return (
    <svg width={size} height={size} className="circular-progress">
      <circle
        cx={size / 2} cy={size / 2} r={r}
        fill="none" stroke="#e8e0d5" strokeWidth="10"
      />
      <circle
        cx={size / 2} cy={size / 2} r={r}
        fill="none" stroke="#781c2e" strokeWidth="10"
        strokeLinecap="round"
        strokeDasharray={circ}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        className="circular-progress__arc"
      />
      <text
        x="50%" y="50%" dominantBaseline="middle" textAnchor="middle"
        className="circular-progress__text"
      >
        {value}%
      </text>
    </svg>
  );
}

function LineChart({ data }) {
  const W = 320, H = 120, PAD = 16;
  const xs = data.map((_, i) => PAD + i * ((W - PAD * 2) / (data.length - 1)));
  const max = 100;
  const ys = data.map(d => H - PAD - (d.score / max) * (H - PAD * 2));
  const points = xs.map((x, i) => `${x},${ys[i]}`).join(" ");

  return (
    <div className="line-chart-wrap">
      <svg viewBox={`0 0 ${W} ${H}`} width="100%" height="100%">
        <defs>
          <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#781c2e" stopOpacity="0.15" />
            <stop offset="100%" stopColor="#781c2e" stopOpacity="0" />
          </linearGradient>
        </defs>
        <polygon
          points={`${PAD},${H - PAD} ${points} ${xs[xs.length - 1]},${H - PAD}`}
          fill="url(#areaGrad)"
        />
        <polyline
          points={points} fill="none"
          stroke="#781c2e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          className="line-chart__path"
        />
        {data.map((d, i) => (
          <circle key={i} cx={xs[i]} cy={ys[i]} r="4" fill="#781c2e" className="line-chart__dot" />
        ))}
        {data.map((d, i) => (
          <text key={i} x={xs[i]} y={H - 2} textAnchor="middle" className="line-chart__label">
            {d.week}
          </text>
        ))}
      </svg>
    </div>
  );
}

function BarChartViz({ data }) {
  const max = Math.max(...data.map(d => d.completion));
  return (
    <div className="bar-chart-viz">
      {data.map((d, i) => (
        <div key={i} className="bar-chart-viz__item">
          <div className="bar-chart-viz__track">
            <div
              className="bar-chart-viz__fill"
              style={{ height: `${(d.completion / max) * 100}%` }}
            >
              <span className="bar-chart-viz__val">{d.completion}%</span>
            </div>
          </div>
          <span className="bar-chart-viz__label">{d.name.split(" ")[0]}</span>
        </div>
      ))}
    </div>
  );
}

// Creates a dedicated modal root div injected AFTER React's #root
// Escapes all layout stacking contexts including transformed sidebars/headers
function getModalRoot() {
  let el = document.getElementById("mc-modal-root");
  if (!el) {
    el = document.createElement("div");
    el.id = "mc-modal-root";
    el.setAttribute("style", [
      "position:fixed",
      "top:0",
      "left:0",
      "width:100vw",
      "height:100vh",
      "z-index:2147483647",
      "pointer-events:none",
      "isolation:isolate",
    ].join(";"));
    document.body.appendChild(el);
  }
  return el;
}

function Modal({ course, onClose }) {
  const [portalRoot, setPortalRoot] = React.useState(null);

  useEffect(() => { setPortalRoot(getModalRoot()); }, []);

  // Body scroll lock
  useEffect(() => {
    if (!course) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [course]);

  // Escape key
  useEffect(() => {
    if (!course) return;
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [course, onClose]);

  if (!course || !portalRoot) return null;

  const modalContent = (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{ pointerEvents: "all" }}
    >
      <div className="modal" onClick={e => e.stopPropagation()}>
        <button className="modal__close" onClick={onClose}><Icons.Close /></button>

        {/* Header */}
        <div className={`modal__header modal__header--${course.accent}`}>
          <div className="modal__header-left">
            <StatusBadge status={course.status} />
            <h2 className="modal__title">{course.title}</h2>
            <p className="modal__instructor">
              <Icons.User /> {course.instructor}
            </p>
          </div>
          <button className="modal__cta">
            <Icons.Play /> Continue Learning
          </button>
        </div>

        {/* Stats row */}
        <div className="modal__stats-row">
          <div className="modal__stat">
            <CircularProgress value={course.progress} size={120} />
            <p className="modal__stat-label">Overall Progress</p>
          </div>
          <div className="modal__stat-list">
            <div className="modal__stat-item">
              <span className="modal__stat-item-label">Lessons Completed</span>
              <span className="modal__stat-item-value">{course.completedLectures}</span>
            </div>
            <div className="modal__stat-item">
              <span className="modal__stat-item-label">Total Lessons</span>
              <span className="modal__stat-item-value">{course.totalLectures}</span>
            </div>
            <div className="modal__stat-item">
              <span className="modal__stat-item-label">Pending Assignments</span>
              <span className="modal__stat-item-value modal__stat-item-value--warn">{course.pendingAssignments}</span>
            </div>
            <div className="modal__stat-item">
              <span className="modal__stat-item-label">Last Activity</span>
              <span className="modal__stat-item-value">{course.lastActivity}</span>
            </div>
          </div>
        </div>

        {/* Charts */}
        <div className="modal__charts">
          <div className="modal__chart-block">
            <h4 className="modal__chart-title"><Icons.Activity /> Weekly Progress</h4>
            <LineChart data={course.weeklyProgress} />
          </div>
          <div className="modal__chart-block">
            <h4 className="modal__chart-title"><Icons.BarChart /> Topic Performance</h4>
            <BarChartViz data={course.topics} />
          </div>
        </div>

        {/* Topics breakdown */}
        <div className="modal__topics">
          <h4 className="modal__chart-title"><Icons.Book /> Topics Breakdown</h4>
          <div className="modal__topics-grid">
            {course.topics.map((t, i) => (
              <div key={i} className="modal__topic-item">
                <div className="modal__topic-header">
                  <span>{t.name}</span>
                  <span className="modal__topic-pct">{t.completion}%</span>
                </div>
                <ProgressBar value={t.completion} accent="garnet" size="sm" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, portalRoot);
}

function CourseCard({ course, onView }) {
  return (
    <div className={`course-card course-card--${course.accent}`}>
      <div className="course-card__top">
        <div className={`course-card__accent-dot course-card__accent-dot--${course.accent}`} />
        <StatusBadge status={course.status} />
      </div>
      <h3 className="course-card__title">{course.title}</h3>
      <p className="course-card__instructor">
        <Icons.User /> {course.instructor}
      </p>
      <div className="course-card__progress-wrap">
        <div className="course-card__progress-header">
          <span>Progress</span>
          <span className="course-card__pct">{course.progress}%</span>
        </div>
        <ProgressBar value={course.progress} accent={course.accent} size="md" />
      </div>
      <div className="course-card__meta">
        <span>{course.completedLectures}/{course.totalLectures} lessons</span>
        <span>{course.lastActivity}</span>
      </div>
      <div className="course-card__actions">
        <button className="btn btn--outline" onClick={() => onView(course)}>View Details</button>
        <button className={`btn btn--primary btn--${course.accent}`}><Icons.Play /> Continue</button>
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <div className="empty-state">
      <Icons.EmptyState />
      <h3 className="empty-state__title">No courses found</h3>
      <p className="empty-state__text">You are not enrolled in any courses yet.</p>
      <button className="btn btn--primary btn--garnet empty-state__cta">Explore Courses</button>
    </div>
  );
}

// ─── MAIN COMPONENT ────────────────────────────────────────────────────────────
export default function MyCourses() {
  const [view, setView] = useState("table");
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [modalCourse, setModalCourse] = useState(null);

  const filtered = useMemo(() => {
    return COURSES.filter(c => {
      const matchSearch = c.title.toLowerCase().includes(search.toLowerCase()) ||
        c.instructor.toLowerCase().includes(search.toLowerCase());
      const matchFilter = filter === "all" || c.status === filter;
      return matchSearch && matchFilter;
    });
  }, [search, filter]);

  const kpis = useMemo(() => {
    const total = COURSES.length;
    const inProgress = COURSES.filter(c => c.status === "in-progress").length;
    const completed = COURSES.filter(c => c.status === "completed").length;
    const avgProgress = Math.round(COURSES.reduce((a, c) => a + c.progress, 0) / total);
    const pending = COURSES.reduce((a, c) => a + c.pendingAssignments, 0);
    return { total, inProgress, completed, avgProgress, pending };
  }, []);

  return (
    <MyStudentLayout>
      <div className="mc-root">
        {/* Page header */}
        <div className="mc-page-header">
          <div>
            <h1 className="mc-page-title">My Courses</h1>
            <p className="mc-page-sub">Track your learning journey and progress</p>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="mc-kpi-row">
          <KpiCard icon={Icons.Book}       label="Total Courses"       value={kpis.total}       accent="garnet"  />
          <KpiCard icon={Icons.Clock}      label="In Progress"         value={kpis.inProgress}   accent="blue"    />
          <KpiCard icon={Icons.CheckCircle}label="Completed"           value={kpis.completed}    accent="green"   />
          <KpiCard icon={Icons.BarChart}   label="Avg Progress"        value={`${kpis.avgProgress}%`} accent="orange" />
          <KpiCard icon={Icons.Clipboard}  label="Pending Assignments" value={kpis.pending}      accent="purple"  />
        </div>

        {/* Control bar */}
        <div className="mc-control-bar">
          <div className="mc-control-bar__left">
            <div className="mc-search">
              <Icons.Search />
              <input
                className="mc-search__input"
                type="text"
                placeholder="Search courses or instructors..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
            <div className="mc-filter">
              <select
                className="mc-filter__select"
                value={filter}
                onChange={e => setFilter(e.target.value)}
              >
                <option value="all">All Courses</option>
                <option value="in-progress">In Progress</option>
                <option value="completed">Completed</option>
              </select>
              <Icons.ChevronDown />
            </div>
          </div>
          <div className="mc-view-toggle">
            <button
              className={`mc-view-toggle__btn ${view === "table" ? "mc-view-toggle__btn--active" : ""}`}
              onClick={() => setView("table")}
              title="Table View"
            >
              <Icons.List /> Table
            </button>
            <button
              className={`mc-view-toggle__btn ${view === "grid" ? "mc-view-toggle__btn--active" : ""}`}
              onClick={() => setView("grid")}
              title="Grid View"
            >
              <Icons.Grid /> Grid
            </button>
          </div>
        </div>

        {/* Content */}
        {filtered.length === 0 ? (
          <EmptyState />
        ) : view === "table" ? (
          <div className="mc-table-wrap">
            <table className="mc-table">
              <thead>
                <tr>
                  <th>Course</th>
                  <th>Instructor</th>
                  <th>Progress</th>
                  <th>Lessons</th>
                  <th>Status</th>
                  <th>Last Activity</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(course => (
                  <tr key={course.id} className="mc-table__row">
                    <td>
                      <div className="mc-table__course-cell">
                        <div className={`mc-table__course-dot mc-table__course-dot--${course.accent}`} />
                        <span className="mc-table__course-name">{course.title}</span>
                      </div>
                    </td>
                    <td className="mc-table__instructor">
                      <Icons.User /> {course.instructor}
                    </td>
                    <td>
                      <div className="mc-table__progress-cell">
                        <ProgressBar value={course.progress} accent={course.accent} size="sm" />
                        <span className="mc-table__progress-pct">{course.progress}%</span>
                      </div>
                    </td>
                    <td className="mc-table__lessons">
                      {course.completedLectures}<span className="mc-table__lessons-total">/{course.totalLectures}</span>
                    </td>
                    <td><StatusBadge status={course.status} /></td>
                    <td className="mc-table__activity">{course.lastActivity}</td>
                    <td>
                      <div className="mc-table__actions">
                        <button className="btn btn--sm btn--outline" onClick={() => setModalCourse(course)}>View</button>
                        <button className={`btn btn--sm btn--primary btn--${course.accent}`}><Icons.Play /> Continue</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="mc-grid">
            {filtered.map(course => (
              <CourseCard key={course.id} course={course} onView={setModalCourse} />
            ))}
          </div>
        )}

        {/* Modal */}
        <Modal course={modalCourse} onClose={() => setModalCourse(null)} />
      </div>
    </MyStudentLayout>
  );
}